// Captura, persiste e expõe o código de referral (?ref=ABC123).
//
// Quando alguém entra com `?ref=` no link, salvamos no localStorage e
// limpamos a URL (UX limpa). Persistimos por 30 dias — se a pessoa só voltar
// dias depois pra fazer signup, ainda contamos a indicação.

const REF_KEY = 'mdc:referral';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

// Captura ?ref= da URL atual. Chamado uma vez no app.jsx init.
export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (!ref) return;
    const code = String(ref).trim().toUpperCase();
    if (!/^[A-Z0-9-]{4,40}$/.test(code)) return;
    window.localStorage.setItem(REF_KEY, JSON.stringify({ code, savedAt: Date.now() }));
    // Limpa o ?ref= sem deixar histórico extra.
    params.delete('ref');
    const next = window.location.pathname + (params.toString() ? `?${params}` : '') + window.location.hash;
    window.history.replaceState({}, '', next);
  } catch { /* SSR safe */ }
}

export function getActiveReferral() {
  try {
    const raw = window.localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const { code, savedAt } = JSON.parse(raw);
    if (Date.now() - savedAt > TTL_MS) {
      window.localStorage.removeItem(REF_KEY);
      return null;
    }
    return code;
  } catch { return null; }
}

export function clearReferral() {
  try { window.localStorage.removeItem(REF_KEY); } catch { /* noop */ }
}

// Gera um código de referral previsível por casamento. Usamos o slug se
// existir (mais bonito de ler — "RODRIGO-BRUNA-A8B2"); caso contrário,
// derivamos do uid (servidor pode regenerar/validar). 4 hex no fim ajuda a
// evitar colisões em casos raros e tornar o código mais único.
export function buildReferralCode({ slug, uid }) {
  const safe = (s) => String(s || '').toUpperCase().replace(/[^A-Z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').slice(0, 24);
  const tail = String(uid || '').replace(/[^A-Za-z0-9]/g, '').slice(0, 4).toUpperCase();
  const base = safe(slug) || 'MIMO';
  return `${base}-${tail || 'A8B2'}`;
}
